import { useOrganisation } from "contexts/OrganisationProvider";
import { OrganisationMembersTable } from "./components/OrganisationMembersTable";
import { AddOrganisationMemberModal } from "./components/AddOrganisationMemberModal";
import { SwitchOrganisationModal } from "./components/SwitchOrganisationModal";

export const OrganisationMembersPage = () => {
  const { organisation, members } = useOrganisation();

  if (!organisation) {
    return null;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <SwitchOrganisationModal />
        <AddOrganisationMemberModal />
      </div>

      <OrganisationMembersTable members={members} />
    </div>
  );
};
